
export type DeleteCardParams = {
/**
 * 사용자 ID (관리자용)
 */
userId?: string;
};
